/**
 * Capa da result page com banda colorida + score grande + resumo executivo.
 * Funciona para IGA (score 0-500) ou BS4IT (score 0-100).
 */
export interface BandHeroProps {
  bandLabel: string
  bandColor: string
  bandSubtitle?: string      // ex: "Forçada por setor altamente regulado"
  score: number
  scoreMax: number
  scoreUnit?: string         // ex: "/100" ou "/500"
  resumoExecutivo?: string
  badgePrefix?: string       // ex: "Banda · ", "Maturidade · "
}

export default function BandHero({
  bandLabel,
  bandColor,
  bandSubtitle,
  score,
  scoreMax,
  scoreUnit,
  resumoExecutivo,
  badgePrefix = 'Banda · ',
}: BandHeroProps) {
  const unit = scoreUnit || `/${scoreMax}`
  return (
    <section className="rounded-2xl border-2 p-6 sm:p-8 text-center"
      style={{ borderColor: bandColor + '50', background: bandColor + '0c' }}>
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider"
        style={{ background: bandColor + '20', color: bandColor, border: `1px solid ${bandColor}60` }}>
        {badgePrefix}{bandLabel}
        {bandSubtitle && <span title={bandSubtitle}>⚖️</span>}
      </div>
      <div className="mt-4 flex items-baseline justify-center gap-2">
        <span className="text-6xl font-black" style={{ color: bandColor }}>
          {score.toFixed(0)}
        </span>
        <span className="text-2xl text-slate-400">{unit}</span>
      </div>
      {resumoExecutivo && (
        <p className="text-sm sm:text-base text-slate-300 mt-4 max-w-3xl mx-auto leading-relaxed">
          {resumoExecutivo}
        </p>
      )}
    </section>
  )
}
